import React, { useState, useEffect } from 'react';
//import { Container, Row, Col } from 'react-bootstrap';
import Lang from 'libraries/Lang';
import { getTopTrendsData } from 'libraries/trendsData';
import DestinationSectionLoader from './destinationSectionLoader';
import TopCruiseDetailSection from './topCruiseDetailSection';

const TopCruises = (prop) => {
    const [topCruises, setTopCruises] = useState(false);
    const [topItems, setTopItems] = useState([]);
    const [activeTitle, setActiveTitle] = useState({"destinations" : "active", "lines" : "", "ships" : ""});
    const [isDataAvailable, setIsDataAvailable] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const getTopCruisesPromise = getTopTrendsData('/api/trends/topSearchedCruises', prop.env, prop.start, prop.end);

        getTopCruisesPromise.then((result) => {
            setIsLoading(false);
            if (result) {
                if (result.isDataAvailable !== undefined && result.isDataAvailable == true) {
                    setTopCruises(result);
                    setTopItems(result.destinations);
                    setIsDataAvailable(true);
                }
            }
        });
    }, []);

    const showDestinations = () => {
        setActiveTitle({"destinations" : "active", "lines" : "", "ships" : ""});
        setTopItems(topCruises.destinations);
    };

    const showLines = () => {
        setActiveTitle({"destinations" : "", "lines" : "active", "ships" : ""});
        setTopItems(topCruises.lines);
    };

    const showShips = () => {
        setActiveTitle({"destinations" : "", "lines" : "", "ships" : "active"});
        setTopItems(topCruises.ships);
    };

    // https://www.redtag.ca/images/hotels/default.jpg
    const defaultImage = 'https://travel-img-assets.s3.us-west-2.amazonaws.com/no-image/no-image-500x300.png';

    return (
        <>
            { isLoading == false ?   
                <>
                    { isDataAvailable !== false ?
                        <div class="p-5 mx-sm-5">
                            <div className="container mb-3 pb-1">
                                <h4 className="font-weight-bold">{Lang.trans('trends_top_cruises.title')}</h4>
                                <p className="font-sm font-weight-600 text-black mb-0">{Lang.trans('trends_top_cruises.title_description')}</p>

                                <nav className="mt-3 text-left list-unstyled nav-tabs tabs-pill-bg d-inline-flex rounded-pill mb-4" role="tablist">
                                    <li className="nav-item text-center">
                                        <a className={`p-2 nav-item d-block rounded-pill px-5 ${activeTitle.destinations}`} id="top-cruise-destination" data-toggle="tab" role="tab" aria-controls="top-cruise-destination" aria-selected="true" onClick={showDestinations}>
                                            {Lang.trans('trends_top_cruises.destinations')}
                                        </a>
                                    </li>
                                    <li className="nav-item text-center">
                                        <a className={`p-2 nav-item d-block rounded-pill px-5 ${activeTitle.lines}`} id="top-cruise-line" data-toggle="tab" role="tab" aria-controls="top-cruise-line" aria-selected="true" onClick={showLines}>
                                            {Lang.trans('trends_top_cruises.lines')}
                                        </a>
                                    </li>
                                    <li className="nav-item text-center">
                                        <a className={`p-2 nav-item d-block rounded-pill px-5 ${activeTitle.ships}`} id="top-cruise-ship" data-toggle="tab" role="tab" aria-controls="top-cruise-ship" aria-selected="true" onClick={showShips}>
                                            {Lang.trans('trends_top_cruises.ships')}
                                        </a>
                                    </li>
                                </nav>

                                <div className="tab-content" id="cruise-categories">
                                    <div className="tab-pane fade show active" id="top-cruise-destination" role="tabpanel" aria-labelledby="sub-tab">
                                        {activeTitle.destinations && activeTitle.destinations == 'active' && (
                                            <TopCruiseDetailSection
                                                topCruises={topCruises}
                                                topItems={topItems}
                                                dataItem={'destinations'}
                                            />
                                        )}
                                        {activeTitle.lines && activeTitle.lines == 'active' && (
                                            <TopCruiseDetailSection
                                                topCruises={topCruises}
                                                topItems={topItems}
                                                dataItem={'lines'}
                                            />
                                        )}
                                        {activeTitle.ships && activeTitle.ships == 'active' && (
                                            <TopCruiseDetailSection
                                                topCruises={topCruises}
                                                topItems={topItems}
                                                dataItem={'ships'}
                                            />
                                        )}
                                        
                                        {/* {topCruises ?
                                            <>
                                                { topItems !== undefined && topItems !== null && topItems.length > 0  ?
                                                    <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-3 row-cols-xl-5 mb-3 gutter-0 box-shadow rounded-sm">
                                                        {topItems.map((item, key) => {
                                                            const currentImgNo = key + 1;
                                                            if(item.name != undefined ) {
                                                                return (
                                                                    <div className="col border-right-dashed border-bottom-dashed blue-hover">
                                                                        <div className="rounded-sm p-2 pt-4">
                                                                            <button className="btn-unstyled deal-list-card text-decoration-none position-relative mt-3">
                                                                                <span className="counter-circle-list rounded-circle center position-absolute z-index-1 font-weight-bold">
                                                                                    {currentImgNo}
                                                                                </span>
                                                                                <div className="position-relative w-100 rounded  overflow-hidden">
                                                                                    <img className="object-fit-cover rounded-circle border p-1 box-shadow" width="185" height="185" src={(item.image != undefined && item.image != '') ? item.image : defaultImage} data-was-processed="true" />
                                                                                    <div className="py-4 text-center">
                                                                                        <h6 className="font-weight-600 my-2 font-size-md">
                                                                                            {(item.long != undefined && item.long != '') ? (item.name + ' in ' + item.long) : item.name}
                                                                                        </h6>
                                                                                    </div>
                                                                                </div>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            }  
                                                        })}
                                                    </div>
                                                :  null }
                                            </>
                                        : null } */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    : null }
                </>
            : <DestinationSectionLoader />}
        </>
    );
};

export default TopCruises;
